// extracted by mini-css-extract-plugin
module.exports = {"description":"specialties_description__xDdDP"};